import {Attribute} from '../../components/ObjectAttribute';
import {Json} from '../../components/JsonObjectCard';
import deletePaymentsRequest from "./requests/deletePaymentsRequest";
import {RequestDefinitionData} from "../../components/RequestDefinition";
import searchPaymentsRequest from "./requests/searchPaymentsRequest";

const paymentsEndpoints: RequestDefinitionData[] = [
    searchPaymentsRequest,
    deletePaymentsRequest
];

export const paymentsHeader = {
    title: 'Payment',
    description: 'This is an object representing a Fishbowl Payment.',
    linkName: 'Payment',
    link: 'https://help.fishbowlinventory.com/advanced/s/article/Payment-Viewer',
    endpoints: paymentsEndpoints,
};

export const jsonObject: Json = {
    title: 'THE PAYMENT OBJECT',
    json: {},
};

export const paymentsAttributes: Attribute[] = [];
